/**
 * Höhe der Chat-Eingabe (T-349): Die Textarea wächst beim Tippen mehrzeiliger
 * Nachrichten mit, bis `COMPOSER_MAX_HOEHE` erreicht ist; ab dann scrollt sie
 * intern. Leer bzw. einzeilig bleibt sie exakt so hoch wie die runden Buttons
 * (`min`), damit Eingabe und Buttons auf einer Achse liegen.
 *
 * Bei `box-sizing: border-box` enthält `scrollHeight` den Rahmen nicht — er
 * wird über `rahmen` (oben + unten) addiert, sonst erschiene ein Scrollbalken,
 * obwohl der Text passt.
 */
export const COMPOSER_MAX_HOEHE = 240;

export function composerHoehe(
  scrollHeight: number,
  opts: { min: number; max: number; rahmen: number },
): { height: number; overflowY: "hidden" | "auto" } {
  const benoetigt = scrollHeight + opts.rahmen;
  const height = Math.min(opts.max, Math.max(opts.min, benoetigt));
  return { height, overflowY: benoetigt > opts.max ? "auto" : "hidden" };
}
